import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import ErrorCover from "../images/error_cover.svg";
import GroupPic from "../images/group.svg";
import Image from "react-bootstrap/Image";
import { People, Globe } from "react-bootstrap-icons";
import { GooglePlay, Apple } from "react-bootstrap-icons";
import Spinner from "react-bootstrap/Spinner";
import { getGroup } from "../api/mainApi";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const Group = () => {
  let params = useParams();
  // Queries
  const { isLoading, isError, isSuccess, data } = useQuery({
    queryKey: ["group"],
    queryFn: async () => await getGroup(params?.username),
    retry: false,
    enabled: !!params?.username,
  });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Join Group</title>
        <link rel="canonical" href="https://boque.me/group" />
        <meta
          name="description"
          content="Use invite link to join a carpool group."
        />
      </Helmet>
      <div
        className="header-small"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col>
              <h1>Join The Carpool Group</h1>
              <p className="mt-3 fs-4">Follow the steps below to join</p>
            </Col>
          </Row>
        </Container>
      </div>
      {isLoading && (
        <Spinner animation="grow" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )}
      {isSuccess && (
        <Container>
          <Row className="mt-3">
            <Col md={5} className="offset-md-1">
              <Card className="bg-white">
                <Card.Body>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <Image
                      src={
                        data?.data?.image_url !== null
                          ? `https://birdflap.s3.eu-west-1.amazonaws.com/${data?.data?.image_url}`
                          : GroupPic
                      }
                      roundedCircle
                      width="200px"
                      height="200px"
                      className="border"
                    />
                    <h4 className="mt-3">{data?.data?.name}</h4>
                    <p className="text-center">
                      <span className="text-secondary">@</span>
                      {data?.data?.username}{" "}
                      <People size={20} color="#64748b" />{" "}
                      <strong>{data?.data?.member_count} </strong>
                      Members
                    </p>
                    <p>
                      {data?.data?.countryDetail?.flag_url !== null ? (
                        <Image
                          src={`https://birdflap.s3.eu-west-1.amazonaws.com/app_images/flags/${data?.data?.countryDetail?.flag_url}`}
                          width="30px"
                          height="20px"
                        />
                      ) : (
                        <Globe size={20} color="#64748b" />
                      )}{" "}
                      {data?.data?.countryDetail?.name}
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <h2 className="mt-3">Join @{data?.data?.username}</h2>
              <p className="mt-3 mb-0 text-secondary">Step 1</p>
              <p className="mb-0 ">Download the Cabbily App.</p>
              <div class="d-grid gap-2 d-md-block">
                <a
                  className="btn btn-primary me-2 mt-md-2"
                  href="https://apps.apple.com/us/app/cabbily/id1624355642"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="d-flex flex-row align-items-center justify-content-center">
                    <Apple size={22} color="#ffffff" className="me-2" />
                    iOS App
                  </div>
                </a>
                <a
                  className="btn btn-primary me-2 mt-md-2"
                  href="https://play.google.com/store/apps/details?id=com.cabbily.cabbily"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="d-flex flex-row align-items-center justify-content-center">
                    <GooglePlay size={22} color="#ffffff" className="me-2" />
                    Android App
                  </div>
                </a>
              </div>
              <p className="mt-3 mb-0 text-secondary">Step 2</p>
              <p className="">
                Login and tap <strong>Join</strong>.
              </p>
              <p className="mt-3 mb-0 text-secondary">Step 3</p>
              <p className="">
                Input <strong>{data?.data?.title}</strong> in the search bar and
                select the group.
              </p>
              <p className="mt-3 mb-0 text-secondary">Final Step</p>
              <p className="">
                Tap <strong>join group</strong>.
              </p>
            </Col>
          </Row>
        </Container>
      )}
      {isError && (
        <Container>
          <Row className="mt-3">
            <Col md={12}>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <Image src={ErrorCover} width="200px" height="200px" />
                <h4 className="mt-3">Group not found</h4>
                <p className="text-center">
                  Check the link to make sure its correct.
                </p>
                <p className="text-center">
                  Check to make sure your internet connection is available.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default Group;
